
import GridLock from "../../../assets/duotone/GridLock.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GridLockIcon({ className, dataTestid = "GridLockIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GridLock data-testid={dataTestid} className={classes} {...rest} />
  );
}
